import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Typography, Box } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/home');
  };

  return (
    <main className="body not-found-page">
      <Box className="not-found-container">
        <div className="not-found-icon">
          <SearchOffIcon />
        </div>
        
        <div className="not-found-content">
          <Typography variant="h1" className="error-code">
            404
          </Typography>
          
          <Typography variant="h4" className="error-title">
            {t('pageNotFound', 'הדף לא נמצא')}
          </Typography>
          
          <Typography variant="body1" className="error-message">
            {t('pageNotFoundMessage', 'הדף שחיפשת לא קיים או שהועבר למקום אחר')}
          </Typography>
          
          <Button
            variant="contained"
            color="primary"
            startIcon={<HomeIcon />}
            onClick={handleGoHome}
            className="home-button"
            size="large"
          >
            {t('backToHome', 'חזרה לדף הבית')}
          </Button>
        </div>
      </Box>
    </main>
  );
};

export default NotFoundPage;